import { format } from 'date-fns';
import { Article } from '../types/article';

// Declare webpack's require.context
declare const require: {
  context: (directory: string, useSubdirectories: boolean, regExp: RegExp) => {
    keys: () => string[];
    (id: string): string;
  };
};

export function loadArticles(): Article[] {
  const ctx = require.context('../articles', false, /\.md$/);
  const articles = ctx.keys().map((key: string) => {
    const content = ctx(key);
    const fileName = key.replace('./', '').replace('.md', '');
    const match = fileName.match(/(.+)-(\d{4}-\d{2}-\d{2})$/);
    const title = match ? match[1].replace(/-/g, ' ') : fileName;
    const date = match ? match[2] : '1970-01-01';
    return {
      title,
      date,
      content,
      fileName,
    };
  });
  const today = format(new Date(), 'yyyy-MM-dd');
  return articles
    .filter((a: Article) => a.date <= today)
    .sort((a: Article, b: Article) => b.date.localeCompare(a.date));
} 